import { Wallet, Vault, Divide } from "lucide-react";

const steps = [
  { icon: Wallet, title: "Hold any amount of $BANK", body: "No minimums, no staking, no lockups. Your wallet balance is your position — the moment you hold, you earn." },
  { icon: Vault, title: "The vault fills with ETH", body: "Creator trading fees from the pons launch are routed into the rewards distributor as ETH between every cycle." },
  { icon: Divide, title: "Split every cycle", body: "Each cycle a snapshot allocates the new ETH by your exact % of eligible supply and publishes a Merkle root. Hold 1.5%, get 1.5% — claim anytime or let the keeper push it to you." },
];

export const HowItWorks = () => (
  <section id="how" className="max-w-7xl mx-auto px-6 py-20">
    <p className="font-mono text-xs tracking-[0.2em] text-[#00C805] uppercase mb-3">How it works</p>
    <h2 className="font-heading font-bold text-lg md:text-lg tracking-tight mb-12">Three steps. Zero effort.</h2>
    <div className="grid md:grid-cols-3 gap-8">
      {steps.map((s, i) => (
        <div key={i} data-testid={`how-step-${i + 1}`} className="card-surface rounded-2xl p-8 hover:border-[#00C805]/30 transition-colors duration-200">
          <div className="flex items-center justify-between mb-6">
            <span className="w-11 h-11 rounded-full bg-[#1A4020] flex items-center justify-center">
              <s.icon size={18} className="text-[#00C805]" />
            </span>
            <span className="font-mono text-4xl font-light text-neutral-800">0{i + 1}</span>
          </div>
          <h3 className="font-heading font-bold text-base mb-3">{s.title}</h3>
          <p className="text-sm text-neutral-400 leading-relaxed">{s.body}</p>
        </div>
      ))}
    </div>
  </section>
);
